<div role="dialog" aria-labelledby="modalAddScheduleMessage" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modalAddScheduleMessage">
          {{ 'attendance.chatTemplateSchedule.addScheduledMessage' | translate }}
          <br>
          <span class="text-muted fw-normal font-14">{{ 'attendance.chatTemplateSchedule.fillDataToScheduleMessage' | translate }}</span>
        </h4>
        <button type="button" class="btn-close" [mat-dialog-close]="true" aria-hidden="true"></button>
      </div>
      <div class="modal-body custom-scroll-bar">
        <input id="tab-one" type="radio" name="tabs" class="peer/tab-one opacity-0 absolute" checked />
        <form [formGroup]="formGroup" (ngSubmit)="saveMessageTemplateScheduled()">
          <div class="textarea-wrapper">
            <div class="d-flex gap-2 mb-3">
              <div class="d-flex flex-column w-100">
                <label class="form-label">{{ 'attendance.chatTemplateSchedule.date' | translate }} *</label>
                <div id="input-phone" class="d-flex w-100 trend-datepicker">
                  <input
                    readonly
                    [matDatepicker]="picker"
                    formControlName="scheduledDay"
                    [placeholder]="'attendance.chatTemplateSchedule.selectDate' | translate"
                    class="w-100 form-control"
                    (focus)="picker.open()"
                  />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </div>

                <field-error-component 
                  [field]="'scheduledDay'" 
                  [label]="'attendance.templateSchedule.dateLabel' | translate"
                  [formGroup]="formGroup"
                />
              </div>
        
              <div class="d-flex flex-column w-100">
                <label class="form-label">{{ 'attendance.chatTemplateSchedule.time' | translate }} *</label>
                <input
                  class="form-control"
                  formControlName="scheduledHour"
                  [placeholder]="'attendance.chatTemplateSchedule.timeExample' | translate"
                  mask="00:00"
                >
                <small class="text-muted mt-1">{{ 'attendance.chatTemplateSchedule.validTimeFormat' | translate }}</small>
                @if(hourErrorMessage) {
                  <div class="d-flex text-danger mt-1">
                    <strong>{{ hourErrorMessage }}</strong>
                  </div>
                }
              </div>
            </div>
            
            @if(!selectedTemplate) {
              <div class="wa-template">
                <wa-template 
                  [channel]="$safeNavigationMigration(data?.attendance?.channel)" 
                  (onSelectTemplate)="onSelectTemplate($event)"
                />
              </div>
            }
            
            @if(selectedTemplate) {
              <div class="p-2 w-100">
                <button
                  class="btn btn-dark mb-3 rounded-pill"
                  (click)="changeTemplate()"
                >
                  {{ 'attendance.chatTemplateSchedule.changeTemplate' | translate }}
                </button>
                <wa-template-message  
                  [variables]="variables"
                  [contact]="selectedContact"
                  [template]="selectedTemplate" 
                  (templateParams)="setTemplateMessage($event)"
                />
              </div>
            }
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              [mat-dialog-close]="true"
            >
              {{ 'attendance.chatTemplateSchedule.cancel' | translate }}
            </button>

            <button
              type="submit"
              [disabled]="loading"
              class="btn btn-primary"
            >
              @if(!loading) {
                {{ 'attendance.chatTemplateSchedule.add' | translate }}
              } @else {
                <mat-spinner 
                  [diameter]="25" 
                  [color]="'accent'" 
                  mode="indeterminate" 
                />
              }
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>